// 2026-10-23 商品ページの画像ギャラリーを GG Product Gallery と同じ動きにする補助。
// GG と同じく、1 枚目では左、最後では右の矢印を押せなくする。
// テーマの scroll-carousel は端に着いた合図（scroll:edge-*）を出さないので、切り替わりの合図（carousel:change）を見て決める。
// 読み込みは snippets/product-gallery.liquid。<pg-gg-arrow-sync aria-controls="カルーセルの id"> を置いたギャラリーだけが対象。

if (!customElements.get('pg-gg-arrow-sync')) {
  customElements.define('pg-gg-arrow-sync', class extends HTMLElement {
    #abortController;

    connectedCallback() {
      customElements.whenDefined('scroll-carousel').then(() => {
        const id = this.getAttribute('aria-controls');
        const carousel = document.getElementById(id);

        if (!carousel || !this.isConnected) {
          return;
        }

        this.#abortController?.abort();
        this.#abortController = new AbortController();

        const update = (index = carousel.selectedIndex ?? 0) => {
          const prev = document.querySelector(`carousel-prev-button[aria-controls="${id}"] .pg-gg-arrow`);
          const next = document.querySelector(`carousel-next-button[aria-controls="${id}"] .pg-gg-arrow`);
          const count = carousel.cells?.length ?? 0;

          if (prev) prev.disabled = index <= 0;
          if (next) next.disabled = index >= count - 1;
        };

        const signal = this.#abortController.signal;
        carousel.addEventListener('carousel:change', (event) => update(event.detail?.index), { signal });
        carousel.addEventListener('carousel:filter', () => requestAnimationFrame(() => update()), { signal });
        update();
      });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }
  });
}
